<template>
    <div class="leftO">
        <breadcrumb :routerList="[{to:'/xiangmu/pm',title:'项目管理'},{title:'报价单'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>基本信息</h1>
                                </div>
                                <div class="h-pieceCon2" style="padding:0">
                                    <div class="h-formLine initiate">
                                        <el-form :model="formLabelAlign" label-position="right" ref="cai"
                                                 :inline="true"
                                                 class="demo-ruleForm h-formbLine h-formbLine1">
                                            <el-form-item label="项目编号" class="h-elformWrap-2" prop="id">
                                                <el-input readonly v-model="formLabelAlign.id"></el-input>
                                            </el-form-item>
                                            <el-form-item label="项目名称" class="h-elformWrap-2" prop="projectName">
                                                <el-input readonly v-model="formLabelAlign.projectName"></el-input>
                                            </el-form-item>
                                            <el-form-item label="项目说明" class="h-elformWrap-1"
                                                          prop="projectDescription">
                                                <!-- <el-input readonly v-model="formLabelAlign.projectDescription"
                                                          maxlength="70" placeholder="请输入">
                                                </el-input> -->
												<div style="width: 100%;border-bottom: 1px solid #dedede;color: #868686;word-break:break-all;padding-left: 0.15rem;">{{formLabelAlign.projectDescription}}</div>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>产品信息</h1>
                                    </div>
                                    <el-table
                                            @selection-change="handleSelectionChange"
                                            ref="multipleTable"
                                            :data="proProductwx"
											:border="true"
                                            style="width: 100%">
                                        <!--                                        <el-table-column-->
                                        <!--                                                type="selection"-->

                                        <!--                                                width="70"-->
                                        <!--                                                :label="all"-->
                                        <!--                                                @header-click="headerClick"-->
                                        <!--                                        >-->
                                        <!--                                        </el-table-column>-->
                                        <el-table-column
                                                type="index"
                                                width="40"
                                                label="#">
                                        </el-table-column>
                                        <el-table-column
                                                prop="typeName"
                                                min-width="90"
                                                label="产品大类">
                                        </el-table-column>

                                        <el-table-column
                                                prop="productName"
                                                label="产品型号"
                                                min-width="150"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                        <el-table-column
                                                prop="productDes"
                                                label="产品描述"
                                                min-width="150"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                        <el-table-column
                                                prop="productNum"
                                                label="数量"
                                                min-width="150"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                    </el-table>
                                    <!-- <div>
                                        <div class="h-txtCenter h-mrt60">
                                            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="addForms">选择供应商
                                            </el-button>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                            <br/>
                            <div class="N-chan">

                                <div v-for="(item,index) in addForm"
                                     :key="index">
                                    <div class="h-pieceTitle2">
                                        <h1>询价分行信息</h1>
                                    </div>
                                    <el-table
                                            ref="multipleTable"
                                            :span-method="objectSpanMethod"
                                            :data="item.proProductInfoList"
											:border="true"
                                            style="width: 100%">
                                        <el-table-column
                                                width="50"
                                                label="all"
                                        >
                                            <template scope="scope">
                                                <div class="selectcicle"
                                                     v-if="taskids && scope.row.isChosen == 1"></div>
                                                <el-radio v-else :label="scope.row.indexLength" v-model="radio"
                                                          :disabled="taskids && scope.row.isChosen == 0"
                                                          style="display: flex;flex-direction: column;margin-top: 0.1rem"
                                                          @change.native="getTemplateRow(scope.$index,scope.row,item.proProductInfoList)">
                                                    &nbsp;
                                                </el-radio>

                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                type="index"
                                                width="40"
                                                label="#">
                                        </el-table-column>
                                        <el-table-column
                                                prop="supplierName"
                                                label="供应商名称"
                                                :show-overflow-tooltip="true"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                                prop="productName"
                                                :show-overflow-tooltip="true"
                                                label="产品型号"
                                                width="220">
                                        </el-table-column>
                                        <el-table-column
                                                prop="productId"
                                                label="产品编码"
                                                :show-overflow-tooltip="true"
                                                width="140">
                                        </el-table-column>
                                        <el-table-column
                                                prop="supplierPrice"
                                                label="报价"
                                                :show-overflow-tooltip="true"
                                                width="100">
                                        </el-table-column>
                                        <el-table-column
                                                prop="priceTerm"
                                                label="报价有效期"
                                                :show-overflow-tooltip="true"
                                                width="220">
                                        </el-table-column>
                                        <el-table-column
                                                label="操作"
                                                width="120"
                                                fixed="right">
                                            <template slot-scope="scope">
                                                <el-button
                                                        type="text"
                                                        size="small"
                                                        class="h-tableLink h-btn"
                                                        @click="chakan(scope.row)">
                                                    查看历史报价
                                                </el-button>
												<!-- <div class="l-operationBox">
													<span class="l-operationlist br-operation-lsbj" title="查看历史报价" @click="chakan(scope.row)"></span>
												</div> -->
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div v-if="item.proProductInfoList&&item.proProductInfoList.length>0"
                                         style="display: flex;justify-content: center;align-items: center;margin: 0.3rem 0;">
                                        <el-button v-if="item.proProductInfoList[0].isChosen == 0"
                                                   class="h-btn h-bBtn h-bgblueQ2" @click="gettijiaos(item.arr2)">提交
                                        </el-button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="h-table h-mrt30 ljjxunjia" v-if="taskids">

                <div class="h-pieceTitle2 hang">
                    <h1 class="h1">审批历史校验材料</h1>
                    <el-form :model="spform" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine ">

                        <el-form-item v-if="caigouxiangmuSP2 > 1" label="采购经理审批详情" class="h-elformWrap-2">
                            <el-input v-model="proPriceInquiry.yzCaigou" disabled></el-input>
                            <brupload
                                    :refid=this.fujianId
                                    reftype="采购经理校验"
                                    :showtime="false"
                                    delflag>
                            </brupload>
                        </el-form-item>

                        <el-form-item v-if="caigouxiangmuSP2 > 2" label="市场人员校验材料" class="h-elformWrap-2">
                            <el-input v-model="proPriceInquiry.yzShichang" disabled></el-input>
                            <brupload
                                    :refid=this.fujianId
                                    reftype="市场人员校验"
                                    :showtime="false"
                                    delflag>
                            </brupload>
                        </el-form-item>
                        <el-form-item v-if="caigouxiangmuSP2 > 3" label="售后经理校验材料" class="h-elformWrap-2">
                            <el-input v-model="proPriceInquiry.yzShouhou" disabled></el-input>
                            <brupload
                                    :refid=this.fujianId
                                    reftype="售后经理校验"
                                    :showtime="false"
                                    delflag>
                            </brupload>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="h-pieceTitle2 hang">
                    <h1 class="h1">审批意见</h1>
                    <el-form :model="spform" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine ">
                        <el-form-item label="审批意见" class="h-elformWrap-2 " style="margin:20px" :required="true">
                            <el-input v-model="spform.shpyj" placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="是否现场校验" class="h-elformWrap-2 " style="margin:20px" :required="true">
                            <el-select v-model="jiaoyanNum"
                                       placeholder="--请选择--"
                                       filterable
                                       style="width:200px;"
                                       size="large">
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="jiaoyanNum == '2'" label="不做现场校验原因" class="h-elformWrap-2 "
                                      style="margin:20px" :required="true">
                            <el-input v-model="spform.yanzheng" placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                        <el-form-item v-if="jiaoyanNum == '1'" label="上传现场校验证明" class="h-elformWrap-2">
                            <brupload
                                    @filecallback="fileback"
                                    :refid=this.fujianId
                                    :reftype="this.caigouxiangmuSP + '校验'"
                                    :showtime="false"
                                    uploadflag
                                    delflag>
                            </brupload>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div v-if="taskids" class="h-txtCenter h-mrt60">
                <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default" @click="fanhui">返回</el-button>
                <el-button class="el-button h-btn h-bBtn h-bgred el-button--default" @click="bohui">驳回</el-button>
                <el-button class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="pass">通过</el-button>
                <el-button class="el-button h-btn el-button--default"
                           @click="viewpress">审批跟踪
                </el-button>
            </div>
            <div v-else class="h-txtCenter h-mrt60">
                <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default" @click="fanhui">返回</el-button>
            </div>
        </div>
        <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>查看历史报价</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines" style="padding:30px 48px;">
                <el-table
                        :data="tableData"
						:border="true"
                        style="width: 100%">
                    <el-table-column
                            type="index"
                            width="40"
                            label="#">
                    </el-table-column>
                    <el-table-column
                            prop="supplierPrice"
                            label="报价"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="supplierTime"
                            label="时间">
                    </el-table-column>
                </el-table>
            </div>
            <div style="display:flex;justify-content:center">
                <el-button class="h-btn h-formBtn" @click="dialogVisible=false" type="primary">确定</el-button>
            </div>
        </el-dialog>
    </div>


</template>

<script>
    import ss from '../../../api/SystemService'

    export default {
        data() {
            return {
                proPriceInquiry: {
                    yzCaigou: "0",
                    yzShichang: "0",
                    yzShouhou: "0",
                    yzXinghao: "0"
                },
                fjCode: '',
                caigouxiangmuSP: '',
                caigouxiangmuSP2: '',
                fujianId: '',
                jiaoyanNum: '',
                spform: {
                    shpyj: '',
                    yanzheng: '',
                },
                yanzhengxinxi: '',
                instid: '',
                radio: '',
                showhistory: false,
                tableData: [],
                dialogVisible: false,
                all: '全部',
                timeOut: null,
                timeOPT: this.timePicker(),
                proProductwx: [],
                formLabelAlign: {},
                info: {},
                infoList: [],
                optionsSupplier: [],
                supplier: [{supplierId: ''}],
                norepeat: [],
                addForm: [],
                multipleSelection: [],
                spanaArrs: [],
                spanArr: [],
                rowNum: 0,
                lengths: '',
                arr2: [],
                taskids: '',
                shen: {},
            }
        },
        created() {
            this.supplierOption();
            this.query();
            this.getproductlist()
            this.taskids = this.$route.query.taskid
            this.instid = this.$route.query.instid
            console.log(this.taskids, "..........")
            this.getRole();
        },
        methods: {
            fileback(x) {
                this.fjCode = x.length;
            },
            //获取角色
            getRole() {
                this.rolelist = this._user.roles;
                console.log('角色', this.rolelist);
                this.rolelist.forEach(elements => {
                    if (elements.id == "caigoujingli") {
                        this.caigouxiangmuSP = 'caigou';
                        this.caigouxiangmuSP2 = '1';
                    }
                    if (elements.id == "swyl_shichang") {
                        this.caigouxiangmuSP = 'shichang';
                        this.caigouxiangmuSP2 = '2';
                    }
                    if (elements.id == "shouh_jingli") {
                        this.caigouxiangmuSP = 'shouhou';
                        this.caigouxiangmuSP2 = '3';
                    }
                    if (elements.id == "swyl_xinghaojl") {
                        this.caigouxiangmuSP = 'xinghao';
                        this.caigouxiangmuSP2 = '4';
                    }

                });
            },
            bohui() {
                this.spform.taskid = this.taskids;
                if (!this.spform.shpyj) {
                    this.$msg.msge("请输入驳回意见!");
                    return;
                }
                ss.ProService.bohui(this.spform).then(rd => {
                    this.$msg.msgs(rd.msg);
                    //刷新右上角的代办个数
                    this.$store.dispatch("searchTasktotal")
                    //跳转回系统的代办列表
                    this.$router.push({path: '/personal/dealCenter'})
                });
            },
            pass() {
                if (!this.jiaoyanNum) {
                    this.$msg.msge("请选择是否校验!");
                    return;
                }
                if (this.jiaoyanNum == '2' && !this.spform.yanzheng) {
                    this.$msg.msge("请输入不做现场校验原因!");
                    return;
                }
                if (this.jiaoyanNum == '1' && this.fjCode < 1) {
                    this.$msg.msge("请上传现场校验附件!");
                    return;
                }

                this.spform.taskid = this.taskids;
                this.spform.fujianId = this.fujianId;
                this.spform.yanzhengxinxi = this.caigouxiangmuSP2;
                console.log('意见:', this.spform.yanzhengxinxi, "fs", this.spform.yanzheng, "sdf", this.spform.fujianId);
                this.$msg.confirm("确认通过?", () => {
                    ss.ProService.pass(this.spform).then(rd => {
                        this.$msg.msgs(rd.msg);
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        //跳转回系统的代办列表
                        this.$router.push({path: '/personal/dealCenter'})
                    });
                });
            },
            // selectFlag(row, index) {
            //     return !row.isSelect;
            // },
            // 查看历史报价
            chakan(item) {
                this.dialogVisible = true;
                ss.ProService.chakanBaoDetail(item.inqueryId, item.id, item.supplierId).then(rd => {
                    console.log(rd, "/.../././../.")
                    this.tableData = rd
                })
                // this.tableData.push(item)
                // console.log(item)
            },
            selectFlag(row, index) {
                for (var i = 0; i < this.addForm.length; i++) {
                    var item = this.addForm[i];
                    for (var j = 0; j < item.length; j++) {
                        console.log('我在这儿呀22', item[j].id, 'fsdf', row.id);
                        if (item[j].id == row.id) {
                            return false;
                        }
                    }
                }
            },
            //选择按钮
            headerClick() {

            },
            getSpanArr(list) {
                this.spanArr = [];
                list.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (list[index].supplierId === list[index - 1].supplierId) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                    return this.spanArr;
                })
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (column.label == 'all' || column.label == '供应商名称') {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

            },
            //日期选择
            timePicker() {
                return {
                    disabledDate(time) {
                        return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000;
                    }
                }
            },
            //勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            query() {
                var id = '';
                if (this.$route.query.id) {
                    id = this.$route.query.id;
                    ss.ProService.proDetail(id).then(rd => {
                        console.log(rd, "项目列表");
                        this.formLabelAlign = rd;

                        this.info = _.clone(this.formLabelAlign);
                        this.info.proProductInfoList = [];
                        //产品信息赋值
                        this.proProductwx = rd.proProductInfoList;
                    });
                } else if (this.$route.query.ywid) {
                    id = this.$route.query.ywid;
                    ss.ProService.getShenpiMain(id).then(rd => {
                        console.log(rd, "项目列表");
                        this.formLabelAlign = rd;

                        this.proPriceInquiry = this.formLabelAlign.proPriceInquiry;
                        this.proPriceInquiry.yzShouhou = this.proPriceInquiry.yzShouhou ==
                        '0' ? "进行现场校验" : "不进行现场校验,原因:  " + this.proPriceInquiry.yzShouhou;
                        this.proPriceInquiry.yzShichang = this.proPriceInquiry.yzShichang ==
                        '0' ? "进行现场校验" : "不进行现场校验,原因:  " + this.proPriceInquiry.yzShichang;
                        this.proPriceInquiry.yzCaigou = this.proPriceInquiry.yzCaigou ==
                        '0' ? "进行现场校验" : "不进行现场校验,原因:  " + this.proPriceInquiry.yzCaigou;
                        this.proPriceInquiry.yzXinghao = this.proPriceInquiry.yzXinghao ==
                        '0' ? "进行现场校验" : "不进行现场校验,原因:  " + this.proPriceInquiry.yzXinghao;
                        this.info = _.clone(this.formLabelAlign);
                        this.info.proProductInfoList = [];

                        //产品信息赋值
                        this.proProductwx = rd.proProductInfoList;
                    });

                }

            },
            supplierOption() {
                ss.ProService.supplierSearchList({}).then(rd => {
                    console.log(rd, "optionsSupplier");
                    this.optionsSupplier = rd;
                })
            },
            changeSupplier() {
                console.log('我在这儿呀,haha', this.addForm);
            },
            adds() {
                var a = {supplierId: ''}
                this.supplier.push(a)
                console.log(this.supplier);
            },
            cancelPro() {
                this.$router.push("/xiangmu/pm");
            },
            submitNew() {
                if (this.supplier.length > 0) {
                    var productList = [];

                    for (var i = 0; i < this.addForm.length; i++) {
                        var item = this.addForm[i];
                        for (var j = 0; j < item.length; j++) {
                            var item2 = item[j];
                            item2.supplierId = _.join(item.supplierId, ",");
                            item2.timeOut = item.timeOut;
                            if (item2.supplierId == '' || item2.timeOut == '') {
                                this.$msg.msge("请完善信息后再提交！");
                                return;
                            }
                            item2.mark = this.addForm.length;
                            productList.push(item2);
                        }
                    }

                    this.$msg.confirm("确认发起询价?", () => {
                        this.formLabelAlign.maxMark = this.addForm.length;
                        this.formLabelAlign.proPriceOfferList = this.supplier;
                        ss.ProService.saveInquiry(this.formLabelAlign).then(rd => {
                            this.$msg.msgs("发起成功！");
                            this.$router.push("/xiangmu/pm");
                        })
                    })
                } else {
                    this.$msg.msge("请选择供应商！");
                }
            },
            zanCun() {

            },
            // delIndex(index) {
            // 	this.supplier.splice(index, 1);
            // 	this.norepeat.splice(index, 1);
            // },
            getproductlist() {
                if (this.$route.query.id) {
                    ss.ProService.proBaoDetail(this.$route.query.id).then(rd => {
                        console.log(rd, "产品列表1");
                        if (rd && rd.length > 0) {
                            this.addForm = rd;

                            for (var i = 0; i < this.addForm.length; i++) {
                                this.addForm[i]['arr2'] = [];
                                for (var s = 0; s < this.addForm[i].proProductInfoList.length; s++) {
                                    this.addForm[i].proProductInfoList[s]['indexLength'] = this.addForm[i].proProductInfoList[s].supplierId + ',' + this.addForm[i].proProductInfoList[s].groupId;
                                    // console.log(this.addForm[i].proProductInfoList[s].indexLength, "/././././././")
                                }
                            }
                            console.log(this.addForm,'列表11111111')
                            for (var i = 0; i < this.addForm.length; i++) {
                                if (this.addForm[i].proProductInfoList.length > 0 && this.addForm[i].proProductInfoList) {
                                    this.lengths = this.addForm[i].proProductInfoList;
                                    this.getSpanArr(this.lengths).then(rd => {
                                        console.log('我在这儿呀', rd);
                                        this.spanaArrs[i] = rd;
                                    })
                                }
                            }

                        }

                    })
                } else if (this.$route.query.ywid) {
                    ss.ProService.getShenpi(this.$route.query.ywid).then(rd => {
                        console.log(rd, "产品列表2");
                        if (rd && rd.length > 0) {
                            this.addForm = rd;
                            this.fujianId = this.addForm[0].proProductInfoList[0].groupId;
                            console.log('附件id', this.fujianId);
                            for (var i = 0; i < this.addForm.length; i++) {

                                this.addForm[i]['arr2'] = []
                                if (this.addForm[i].proProductInfoList.length > 0 && this.addForm[i].proProductInfoList) {
                                    this.lengths = this.addForm[i].proProductInfoList;
                                    this.getSpanArr(this.lengths)
                                }
                            }

                        }

                    })
                }

            },
            // 审批跟踪
            viewpress(r) {
                this.showhistory = true;
            },
            // 单选
            getTemplateRow(index, row, list) {
                console.log(index, row)
                console.log(list)
                var arr1 = [];
                this.arr2 = [];
                var obj = {}
                for (var i = 0; i < list.length; i++) {
                    if (row.supplierId == list[i].supplierId) {
                        arr1.push(list[i])
                    }
                }
                obj.supplierId = arr1[0].supplierId
                obj.inquiryId = arr1[0].inqueryId
                this.arr2.push(obj)
                for (var j = 0; j < this.addForm.length; j++) {
                    var ins = this.addForm[j].proProductInfoList.indexOf(row)
                    console.log(ins, "///////////")
                    if (ins > -1) {
                        this.addForm[j]['arr2'] = this.arr2;
                    }
                }
                console.log(this.addForm, "选中")
            },
            // 单个提交
            gettijiaos(data, index) {
                console.log(data)
                console.log(index)
                ss.ProService.commitInquiry(data).then(rd => {
                    console.log(rd, "/////")
                    if (rd.f) {
                        this.$msg.msgs(rd.msg)
                        this.getproductlist()
                        this.radio = ''
                    } else {
                        this.$msg.msge(rd.msg)
                    }
                })

            },
            // 返回
            fanhui() {
                if (this.taskids) {
                    this.$router.push({path: '/personal/dealCenter'});
                } else {
                    this.$router.go(-1);
                }
            }
        }
    }

</script>


<style>
    .initiate .h-formbLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }

    .initiate .h-formbLine .el-form-item__content {
        width: 69%;
    }

    .initiate .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .initiate .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .initiate .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
    }

    .initiate .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 90.3%;
    }

    .ljjxunjia .h-formbLine .el-form-item__label {
        width: 18%;
    }

    .ljjxunjia .h-formbLine .el-form-item__content {
        width: 82%;
    }
</style>
<style scoped>
    .ljjxunjia {
        background-color: white;
        padding: 0 20px;
    }

    .hang {
        padding: 20px 0;
        background-color: white;
    }

    .selectcicle {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        border: 4px solid #409EFF;
        background: #fff;
        margin: 0 auto;
    }
</style>
